import React, { useContext } from 'react';
import { string, bool } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ComponentPlaceholder } from '@thd-olt-component-react/loading-placeholder';

const RelatedSearchPlaceholder = ({ color, showLoadingAnimation }) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  return (
    <ComponentPlaceholder
      height={isMobile ? 370 : 450}
      rows={isMobile ? 10 : 11}
      color={color}
      showLoadingAnimation={showLoadingAnimation}
    />
  );
};

RelatedSearchPlaceholder.propTypes = {
  color: string,
  showLoadingAnimation: bool
};

RelatedSearchPlaceholder.defaultProps = {
  color: '#E0E0E0',
  showLoadingAnimation: false
};

export { RelatedSearchPlaceholder };